export default {
  HOMEPAGE: {
    TITLE: 'Selamat Datang di <br> Altus Indonesia',
    SUBTITLE: 'PT Altus Logistics Services Indonesia provides innovative, customized, integrated services to various Oil and Gas Clients in Indonesia, such as Logistics, Supply Base Management, Marine Agency Services, Manpower Services, Accommodation Cabin and Offshore Cargo Carrying Unit rental, as well as other Oilfield Support Services in the industry.',
    MORE_INFORMATION: 'More Information'
  }
}
